import { MessageCircle } from "lucide-react"
import { Button } from "../ui/button"
import { Input } from "../ui/input"
import { Textarea } from "../ui/textarea"
import { Label } from "../ui/label"

export default function ContactSection() {
  const handleWhatsApp = () => {
    // Mensaje genérico para WhatsApp
    const mensaje = encodeURIComponent("Hola, me comunico desde la web de Gamaan, me gustaría recibir más información.")
    window.open(`https://wa.me/5493571626547?text=${mensaje}`, "_blank")
  }

  const handleEmail = (e) => {
    e.preventDefault()
    const name = document.getElementById("name").value
    const email = document.getElementById("email").value
    const message = document.getElementById("message").value

    // Mensaje que se va a incluir en el mail
    const subject = encodeURIComponent("Consulta desde la web de Gamaan")
    const body = encodeURIComponent(`Nombre: ${name}\nEmail: ${email}\n\nMensaje:\n${message}`)

    // Esto abre el cliente de correo predeterminado
    window.location.href = `mailto:gamaanprendarios@gmail.com?subject=${subject}&body=${body}`
  }

  return (
    <section id="contacto" className="py-16 bg-[#F8F8F8]">
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl mb-4">Contacto</h2>
          <p className="text-muted-foreground max-w-[700px] mx-auto">
            Estamos para ayudarte. No dudes en comunicarte con nosotros.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-[1000px] mx-auto">
          <div className="space-y-6">
            <div>
              <h3 className="text-xl font-bold mb-2">Dirección</h3>
              <p className="text-muted-foreground">Garibaldi esquina General Paz, Río Tercero, Córdoba</p>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-2">Teléfono</h3>
              <p className="text-muted-foreground">+54 9 3571 62-6547</p>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-2">Email</h3>
              <p className="text-muted-foreground">gamaanprendarios@gmail.com</p>
            </div>
            <div>
              <h3 className="text-xl font-bold mb-2">Horario de atención</h3>
              <p className="text-muted-foreground">Lunes a Viernes de 9:00 a 18:00</p>
            </div>
            <Button
              onClick={handleWhatsApp}
              className="bg-[#25D366] hover:bg-[#128C7E] text-white w-full"
              size="lg"
            >
              <MessageCircle className="mr-2 h-4 w-4" /> Contactanos por WhatsApp
            </Button>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-sm">
            <form className="space-y-4" onSubmit={handleEmail}>
              <div className="space-y-2">
                <Label htmlFor="name">Nombre completo</Label>
                <Input id="name" placeholder="Tu nombre" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" placeholder="tu@email.com" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="message">Mensaje</Label>
                <Textarea id="message" placeholder="¿En qué podemos ayudarte?" rows={4} />
              </div>
              <Button className="w-full bg-[#003226] hover:bg-[#DBC5A8] hover:text-[#003226]" type="submit">
                Enviar mensaje
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>
  )
}
